import { render, staticRenderFns } from "./WaybillInventory.vue?vue&type=template&id=2a66d7c0&scoped=true&"
import script from "./WaybillInventory.vue?vue&type=script&lang=js&"
export * from "./WaybillInventory.vue?vue&type=script&lang=js&"
import style0 from "./WaybillInventory.vue?vue&type=style&index=0&id=2a66d7c0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a66d7c0",
  null
  
)

export default component.exports